/**
 * The *Fix and re-solve* door (#1960): one ghost button that opens the flow
 * for an absence. Rendered in the ladder's out-sick footer and on each item
 * of the Review cover inbox; `onOpened` lets the door close itself (the
 * inbox card) — the ladder closes anyway, as the panel takes the drawer slot.
 */
import { useIsDemoSession } from "../../lib/AuthContext";
import { type FixAndResolveAbsent, useFixAndResolveStore } from "../../store/fixAndResolveRequest";
import { Button } from "../ui";

export interface FixAndResolveButtonProps {
  teamId: string;
  cycleId: string;
  date: string;
  absent: FixAndResolveAbsent[];
  onOpened?: (() => void) | undefined;
  testid?: string | undefined;
}

export function FixAndResolveButton({
  teamId,
  cycleId,
  date,
  absent,
  onOpened,
  testid = "fix-resolve-open",
}: FixAndResolveButtonProps) {
  const open = useFixAndResolveStore((s) => s.openFixAndResolve);
  const isDemo = useIsDemoSession();
  // #2824 - a demo runs no live solve.
  if (isDemo) return null;
  return (
    <Button
      type="button"
      size="sm"
      variant="ghost"
      data-testid={testid}
      onClick={() => {
        onOpened?.();
        open({ teamId, cycleId, date, absent });
      }}
    >
      Fix and re-solve
    </Button>
  );
}

export default FixAndResolveButton;
